import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { DataProviderScope } from '@/lib/data';
import { PageLoading } from '@/components/ui/Loading';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { DemoLoginRedirect } from '@/routes/DemoLoginPage';

const LandingPage = lazy(() => import('@/routes/LandingPage'));
const MenuPage = lazy(() => import('@/routes/MenuPage'));
const DrCalorieDemoPage = lazy(() => import('@/routes/DrCalorieDemoPage'));
// The owner's panel (own shell, nested routes, own session gate).
const AdminApp = lazy(() => import('@/admin/AdminApp'));
const DemoLoginPage = lazy(() => import('@/routes/DemoLoginPage'));
const SharePayPage = lazy(() => import('@/routes/SharePayPage'));
// Compile-time gate: the review gallery must not enter the production bundle.
const LoadingPreviewPage = import.meta.env.DEV ? lazy(() => import('@/routes/LoadingPreviewPage')) : null;

function RouteFallback() {
  const { pathname } = useLocation();
  return (
    <main id="main"><PageLoading branded={pathname === '/'} /></main>
  );
}

export function App() {
  return (
    <ErrorBoundary>
      <DataProviderScope>
        <BrowserRouter>
          <DemoLoginRedirect />
          <a className="gs-skip" href="#main">
            رفتن به محتوای اصلی
          </a>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              {/* The restaurant's own live ordering page (separate integration), kept apart from the Garson demo menu. */}
              <Route path="/demo/dr-calorie-official" element={<DrCalorieDemoPage />} />
              {/* The QR on the table encodes /demo/:slug?table=12 */}
              <Route path="/demo/:slug" element={<MenuPage />} />
              <Route path="/demo-login" element={<DemoLoginPage />} />
              <Route path="/admin/*" element={<AdminApp />} />
              {/* The old operator console now lives in the panel as the live order board. */}
              <Route path="/demo-admin" element={<Navigate to="/admin/orders" replace />} />
              <Route path="/pay/share/:token" element={<SharePayPage />} />
              {LoadingPreviewPage && <Route path="/dev/loading" element={<LoadingPreviewPage />} />}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </DataProviderScope>
    </ErrorBoundary>
  );
}
